import React from 'react';
import { FilterOptions, FilterOrders } from '../../hooks/useFilters';
import { permissionsGroup } from '../priviledge/PriviledgeProvider';
import DynamicTableColumns from './components/DynamicTableColumns';
import MainTableWaitColumnConfig from "./components/MainTableWaitColumnConfig";

export interface PaginationProps {
    pageCount: number,
    currentPage: number,
    pageSize: number,
    totalCount: number,
    handlePagination: Function,
    handlePerPage: Function,
}

export interface RowColorRule {
    column: string;
    values: string[] | null;
    bgColor: string;
    rowBorder?: string;
}

export type RowColorRules = RowColorRule[];

interface CustomTableProps {
    id: string;
    data: any[];
    columnOrder?: string[];
    columnsNotShown?: string[];
    isLoading?: boolean;
    viewFilters?: boolean;
    filters: FilterOptions;
    updateFilters?: Function;
    updateFilterOrder?: Function;
    defaultOrder?: FilterOrders | undefined;
    pagination?: boolean;
    paginationData?: PaginationProps;
    overrideColumns?: { key: string; columnNameKey?: string | null; permissions?: { group: permissionsGroup; permission: string }[]; render: Function; customHeader?: string|null}[];
    additionalColumns?: { id: string; header: string; render: Function; enableSorting?: boolean }[];
    actions?: { label: string; permissions?: { group: permissionsGroup; permission: string }; render: Function }[];
    multiActions?: { label: string; permissions?: { group: permissionsGroup; permission: string }; render: Function }[];
    handleMultipleDelete?: Function;
    multiDeletePermission?: { action: string; group: permissionsGroup } | null;
    search?: boolean;
    filter?: boolean;
    toggleFilters?: Function;
    children?: React.ReactNode;
    largeTable?: boolean;
    columnsNoSortables?: any;
    isSortable?: boolean;
    addicionalButtons?: React.ReactNode;
    showId?: boolean;
    classNameTable?: string;
    divClassName?: string;
    headerTableClassName?: string;  
    disabledIds?: string[] | null;
    customRowsBackgroundColors?: RowColorRules;
    footerRow?: (() => Record<string, any>) | null;
    renderRowDropdown?: (row: any) => Record<string, any> | null;
}
const CustomTable: React.FC<CustomTableProps> = (
    {
        id,
        data,
        columnOrder,
        columnsNotShown,
        isLoading,
        overrideColumns,
        additionalColumns,
        actions,
        viewFilters = true,
        multiActions,
        handleMultipleDelete,
        multiDeletePermission,
        filters,
        updateFilters,
        updateFilterOrder,
        defaultOrder,
        pagination = true,
        paginationData,
        search = true,
        filter = true,
        toggleFilters,
        children,
        largeTable = false,
        columnsNoSortables = [],
        isSortable = false,
        showId= false,
        addicionalButtons = null,
        classNameTable = '',
        headerTableClassName = '',
        divClassName = '',
        disabledIds = null,
        customRowsBackgroundColors = [],
        footerRow = null,
        renderRowDropdown,
    }
) => {
    const { configuredColumns } = DynamicTableColumns({
        id,
        data,
        columnsNotShown,
        overrideColumns,
        additionalColumns,
        actions,
        columnOrder,
        showId,
        disabledIds
    });

    return (
        <>
            {configuredColumns !== null && (
                <MainTableWaitColumnConfig
                    id={id}
                    data={data}
                    defaultColumnConfig={configuredColumns}
                    filters={filters}
                    multiActions={multiActions}
                    handleMultipleDelete={handleMultipleDelete}
                    multiDeletePermission={multiDeletePermission}
                    isLoading={isLoading}
                    viewFilters={viewFilters}
                    pagination={pagination}
                    paginationData={paginationData}
                    search={search}
                    defaultOrder={defaultOrder}
                    updateFilterOrder={updateFilterOrder}
                    updateFilters={updateFilters}
                    toggleFilters={toggleFilters}
                    filter={filter}
                    children={children}
                    largeTable={largeTable}
                    columnsNoSortables={columnsNoSortables}
                    isSortable={isSortable}
                    addicionalButtons={addicionalButtons}
                    classNameTable={classNameTable}
                    divClassName={divClassName}
                    headerTableClassName={headerTableClassName}
                    customRowsBackgroundColors={customRowsBackgroundColors}
                    footerRow={footerRow}
                    renderRowDropdown={renderRowDropdown}
                />
            )}
        </>
    );
};

export default CustomTable;